<template>
	<div>
		<p>{{ $i18n.shapeFieldsMissing }}</p>
	</div>
</template>
